module.exports = __webpack_public_path__ + "img/flight.8b86aae6.png";